import api from './client';

export const getGroups   = ()             => api.get('/chat/groups');
export const createGroup = (data)         => api.post('/chat/groups', data);
export const updateGroup = (id, data)     => api.put(`/chat/groups/${id}`, data);
export const deleteGroup = (id)           => api.delete(`/chat/groups/${id}`);
export const getMessages = (id, params)   => api.get(`/chat/groups/${id}/messages`, { params });
export const sendMessage     = (id, content, attachments) =>
  api.post(`/chat/groups/${id}/messages`, { content, attachments });
export const uploadChatFile  = (formData) =>
  api.post('/chat/upload', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
export const deleteMessage   = (id)       => api.delete(`/chat/messages/${id}`);
export const editMessage     = (id, content) => api.patch(`/chat/messages/${id}`, { content });
export const markRead    = (id)           => api.post(`/chat/groups/${id}/read`);
export const getDm       = (userId)       => api.post('/chat/dm', { userId });
export const getChatUsers = ()            => api.get('/chat/users');
export const leaveGroup  = (id)           => api.post(`/chat/groups/${id}/leave`);
